import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Pattern / Themes / Gentle suggestion tile. Moved verbatim from journals.tsx
 * so Weekly and Monthly render the same tile. */
export function InsightCard({
  icon,
  tint,
  title,
  body,
  emphasis,
}: {
  icon: ReactNode;
  tint: string;
  title: string;
  body: string;
  emphasis?: boolean;
}) {
  return (
    <div className="flex gap-3">
      <div className={cn("flex h-8 w-8 shrink-0 items-center justify-center rounded-full", tint)}>
        {icon}
      </div>
      <div className="min-w-0">
        <p className="font-display text-[15px] font-medium text-foreground">{title}</p>
        <p
          className={cn(
            "mt-1 text-xs leading-relaxed",
            emphasis ? "text-foreground/75" : "text-muted-foreground",
          )}
        >
          {body}
        </p>
      </div>
    </div>
  );
}
